import DialogCard from './DialogCard'

export default DialogCard